import React from 'react';
import {
  FaAngleLeft,
  FaAngleRight,
  FaCalendarAlt,
  FaPlus,
} from 'react-icons/fa';
import { Link } from 'react-router-dom';

const BlogGroupFour = () => {
  return (
    <>
      {/* blog area start */}
      <div className="blog-area blog-area_group_1 pd-top-120 pd-bottom-120">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-md-6">
              <div className="single-blog-list style-3">
                <div className="thumb">
                  <img src="assets/img/blog/4.png" alt="img" />
                </div>
                <div className="details">
                  <ul className="blog-meta">
                    <li>
                      <span>
                        <img src="assets/img/testimonial/1.png" alt="img" />
                      </span>{' '}
                      Admin
                    </li>
                    <li>
                      <FaCalendarAlt className="mb-1" /> Category
                    </li>
                  </ul>
                  <h5 className="mb-3">
                    <Link to="/blog-details">
                      Transforming businesses, one pixel at a time
                    </Link>
                  </h5>
                  <p>
                    Lorem ipsum dolor sit consectetur Malesuada sed diam in the
                    aliquam
                  </p>
                  <div className="btn-wrap text-end pe-2">
                    <Link className="read-more-text" to="/blog-details">
                      Read More <FaPlus className="mb-1" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="single-blog-list style-3">
                <div className="thumb">
                  <img src="assets/img/blog/5.png" alt="img" />
                </div>
                <div className="details">
                  <ul className="blog-meta">
                    <li>
                      <span>
                        <img src="assets/img/testimonial/1.png" alt="img" />
                      </span>{' '}
                      Admin
                    </li>
                    <li>
                      <FaCalendarAlt className="mb-1" /> Category
                    </li>
                  </ul>
                  <h5 className="mb-3">
                    <Link to="/blog-details">
                      The Importance of a Strong Digital for Strategy
                    </Link>
                  </h5>
                  <p>
                    Lorem ipsum dolor sit consectetur Malesuada sed diam in the
                    aliquam
                  </p>
                  <div className="btn-wrap text-end pe-2">
                    <Link className="read-more-text" to="/blog-details">
                      Read More <FaPlus className="mb-1" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="single-blog-list style-3">
                <div className="thumb">
                  <img src="assets/img/blog/6.png" alt="img" />
                </div>
                <div className="details">
                  <ul className="blog-meta">
                    <li>
                      <span>
                        <img src="assets/img/testimonial/1.png" alt="img" />
                      </span>{' '}
                      Admin
                    </li>
                    <li>
                      <FaCalendarAlt className="mb-1" /> Category
                    </li>
                  </ul>
                  <h5 className="mb-3">
                    <Link to="/blog-details">
                      Creating Engaging Content: A Guide for Digital
                    </Link>
                  </h5>
                  <p>
                    Lorem ipsum dolor sit consectetur Malesuada sed diam in the
                    aliquam
                  </p>
                  <div className="btn-wrap text-end pe-2">
                    <Link className="read-more-text" to="/blog-details">
                      Read More <FaPlus className="mb-1" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="single-blog-list style-3">
                <div className="thumb">
                  <img src="assets/img/blog/7.png" alt="img" />
                </div>
                <div className="details">
                  <ul className="blog-meta">
                    <li>
                      <span>
                        <img src="assets/img/testimonial/1.png" alt="img" />
                      </span>{' '}
                      Admin
                    </li>
                    <li>
                      <FaCalendarAlt className="mb-1" /> Category
                    </li>
                  </ul>
                  <h5 className="mb-3">
                    <Link to="/blog-details">
                      Transforming businesses, one pixel at a time
                    </Link>
                  </h5>
                  <p>
                    Lorem ipsum dolor sit consectetur Malesuada sed diam in the
                    aliquam
                  </p>
                  <div className="btn-wrap text-end pe-2">
                    <Link className="read-more-text" to="/blog-details">
                      Read More <FaPlus className="mb-1" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="single-blog-list style-3">
                <div className="thumb">
                  <img src="assets/img/blog/8.png" alt="img" />
                </div>
                <div className="details">
                  <ul className="blog-meta">
                    <li>
                      <span>
                        <img src="assets/img/testimonial/1.png" alt="img" />
                      </span>{' '}
                      Admin
                    </li>
                    <li>
                      <FaCalendarAlt className="mb-1" /> Category
                    </li>
                  </ul>
                  <h5 className="mb-3">
                    <Link to="/blog-details">
                      The Importance of a Strong Digital for Strategy
                    </Link>
                  </h5>
                  <p>
                    Lorem ipsum dolor sit consectetur Malesuada sed diam in the
                    aliquam
                  </p>
                  <div className="btn-wrap text-end pe-2">
                    <Link className="read-more-text" to="/blog-details">
                      Read More <FaPlus className="mb-1" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="single-blog-list style-3">
                <div className="thumb">
                  <img src="assets/img/blog/9.png" alt="img" />
                </div>
                <div className="details">
                  <ul className="blog-meta">
                    <li>
                      <span>
                        <img src="assets/img/testimonial/1.png" alt="img" />
                      </span>{' '}
                      Admin
                    </li>
                    <li>
                      <FaCalendarAlt className="mb-1" /> Category
                    </li>
                  </ul>
                  <h5 className="mb-3">
                    <Link to="/blog-details">
                      Creating Engaging Content: A Guide for Digital
                    </Link>
                  </h5>
                  <p>
                    Lorem ipsum dolor sit consectetur Malesuada sed diam in the
                    aliquam
                  </p>
                  <div className="btn-wrap text-end pe-2">
                    <Link className="read-more-text" to="/blog-details">
                      Read More <FaPlus className="mb-1" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="pagination">
            <Link className="prev page-numbers" to="#">
              <FaAngleLeft className="mb-1" />
            </Link>
            <Link className="page-numbers" to="#">
              1
            </Link>
            <span className="page-numbers current">2</span>
            <Link className="page-numbers" to="#">
              3
            </Link>
            <Link className="page-numbers" to="#">
              4
            </Link>
            <Link className="next page-numbers" to="#">
              <FaAngleRight className="mb-1" />
            </Link>
          </div>
        </div>
      </div>
      {/* blog area end */}
    </>
  );
};

export default BlogGroupFour;
